module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-barrel-shadow-4.13e2cc3a.png";